
export const CONNECTION_ERROR_MESSAGES: Record<string, string> = {
  CONNECTION_OWNED_BY_OTHER_USER:
    'This wallet address or API key is already linked to another account. Please use a different one.',
  CONNECTION_ALREADY_EXISTS:
    'You already have this connection. Check your existing connections below.',
  DUPLICATE_CONNECTION:
    'You already have this connection. Check your existing connections below.',
  INVALID_API_KEY: 'The API key looks invalid. Double-check it and try again.',
  INVALID_API_SECRET: 'The API secret looks invalid. Double-check it and try again.',
  INVALID_API_CREDENTIALS:
    'We could not authenticate with those API credentials. Make sure they are correct and read-only.',
  EXCHANGE_PERMISSION_DENIED:
    'These API keys are missing read permission. Create a new read-only key and try again.',
  INVALID_WALLET_ADDRESS: 'That wallet address is not valid. Please check it and try again.',
  INVALID_ADDRESS: 'That wallet address is not valid. Please check it and try again.',
  UNSUPPORTED_CHAIN: 'This chain is not supported yet.',
  CONNECTION_NOT_FOUND: 'This connection no longer exists. It may have already been removed.',
  SYNC_ALREADY_IN_PROGRESS: 'A sync is already running for this connection. Please wait for it to finish.',
  SYNC_IN_PROGRESS: 'A sync is already running for this connection. Please wait for it to finish.',
  RATE_LIMITED: 'Too many requests right now. Please wait a moment and try again.',
};

function looksLikeErrorCode(value: string): boolean {
  return /^[A-Z][A-Z0-9_]*$/.test(value);
}


function looksLikeInternalError(value: string): boolean {
  if (/[A-Z][A-Z0-9]*_[A-Z0-9_]+/.test(value)) return true;
  if (/\b(not configured|misconfigured|ECONNREFUSED|ETIMEDOUT|ENOTFOUND)\b/i.test(value)) return true;
  return false;
}


export function resolveConnectionErrorMessage(err: unknown, fallback: string): string {
  const e = err as {
    error?: { metadata?: { message?: unknown }; messagePath?: unknown; message?: unknown };
  } | null;

  const candidates = [
    e?.error?.metadata?.message,
    e?.error?.messagePath,
    e?.error?.message,
  ];

  for (const candidate of candidates) {
    if (typeof candidate !== 'string') continue;
    const raw = candidate.trim();
    if (!raw) continue;
    if (CONNECTION_ERROR_MESSAGES[raw]) return CONNECTION_ERROR_MESSAGES[raw];
    if (looksLikeErrorCode(raw)) continue;
    if (looksLikeInternalError(raw)) continue;
    return raw;
  }

  return fallback;
}
